
import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RolComponent }    from './rol.component';

const SECURITY_ROUTES: Routes = [
  { path: 'security/rol', component: RolComponent }
];

export const ROUTABLE_COMPONENTS = [
];

@NgModule({
  imports: [
    RouterModule.forChild(SECURITY_ROUTES)
  ],
  exports: [
    RouterModule
  ],
  providers: []
})
export class RolRoutingModule {}